import { PanelBarOption } from 'components/panel-bar/types'
import React from 'react'
import UpcomingBlastsComponent from './upcoming-blasts'
import { HistoryBlastsComponent } from './history-blasts'

export const allSections: PanelBarOption[] = [
  {
    category: '',
    component: UpcomingBlastsComponent,
    icon: <i className="fa fa-calendar" aria-hidden="true"></i>,
    name: 'Upcoming',
    route: '',
  },
  {
    category: '',
    component: HistoryBlastsComponent,
    icon: <i className="fa fa-history" aria-hidden="true"></i>,
    name: 'History',
    route: 'history',
  },
]
